import { PureComponent } from "react";
import { AboveTheFoldOnlyServerRender } from "above-the-fold-only-server-render";
import BaseLayoutSegmentComponent from "/components/segments/base-layout-segment/base-layout-segment-component";
import { SegmentContext } from "/contexts/segment-context";

export default class SegmentsLayoutListComponent extends PureComponent {
  shouldRenderSegmentOnServer(segmentIndex) {
    let { numberOfAboveTheFoldSegments } = this.props;
    numberOfAboveTheFoldSegments = parseInt(numberOfAboveTheFoldSegments);

    if (!numberOfAboveTheFoldSegments) return true;

    return segmentIndex < numberOfAboveTheFoldSegments;
  }

  render() {
    const { segments, isPreview, isUserLoggedIn, extraProps } = this.props;

    return (
      <div className="segments-layout-list-component" id="segments-layout-list-component">
        {segments.map((segment, index) => {
          const allowSSR = this.shouldRenderSegmentOnServer(index);

          return (
            <AboveTheFoldOnlyServerRender skip={!allowSSR} key={index}>
              <SegmentContext.Provider
                value={{
                  isFirstSegment: index === 0
                }}
              >
                <BaseLayoutSegmentComponent
                  isPreview={isPreview}
                  extraProps={extraProps}
                  segment={segment}
                  isUserLoggedIn={isUserLoggedIn}
                  index={index}
                />
              </SegmentContext.Provider>
            </AboveTheFoldOnlyServerRender>
          );
        })}
      </div>
    );
  }
}
